import { Component, OnDestroy, OnInit, HostListener } from '@angular/core'
import { IsContentEditableEnabled as IsContentEditableEnabledAction } from '@containers/i18n/store/i18n.actions'
import { isContentEditableEnabled } from '@containers/i18n/store/i18n.selector'
import { select, Store } from '@ngrx/store'
import { TranslateService } from '@ngx-translate/core'
import { ShowSnackbar } from '@shared/shared.actions'
import { Observable } from 'rxjs'
import { tap } from 'rxjs/operators'

@Component({
  selector: 'app-toggle-content-editable',
  templateUrl: './toggle-content-editable.component.html',
  styleUrls: ['./toggle-content-editable.component.scss'],
})
export class ToggleContentEditableComponent implements OnInit {
  private _isEnabled = false
  isContentEditableEnabled$: Observable<boolean>

  constructor(
    private store: Store<any>,
    private translateService: TranslateService,
  ) {}

  ngOnInit() {
    this.isContentEditableEnabled$ = this.store.pipe(
      select(isContentEditableEnabled),
      tap((isEnabled) => (this._isEnabled = isEnabled)),
    )
  }

  @HostListener('window:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (event.ctrlKey && event.key === '.') {
      event.preventDefault()
      event.stopPropagation()
      this.toggle()
    }
  }

  toggle() {
    this.store.dispatch(
      new ShowSnackbar({
        type: 'success',
        message: this.translateService.instant(
          !this._isEnabled
            ? 'CONTENT_TRANSLATION_ENABLE'
            : 'CONTENT_TRANSLATION_DISABLE',
        ),
      }),
    )
    this.store.dispatch(new IsContentEditableEnabledAction(!this._isEnabled))
  }
}
